import React from "react";

const DigitalMarketingBenefits = () => {
  return (
    <div className="w-full px-4 sm:px-8 md:px-12 lg:px-40 text-gray-800 font-poppins py-4">
      <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold mb-10 md:px-24 text-center md:text-center">
        Our Work Process
      </h1>

      <div className="md:space-y-6 space-y-8 md:px-24">
        <div className="transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg hover:bg-gray-50 p-4 rounded-lg">
          <h2 className="font-bold text-xl sm:text-2xl lg:text-3xl border-b-4 border-[#0F6CB4] inline-block pb-1">
            Discovery & Consultation
          </h2>
          <p className="pt-2 text-sm sm:text-base">
            We begin by understanding your unique business challenges and goals through in-depth consultation,<br></br> ensuring we align our solutions with your vision.
          </p>
        </div>

        <div className="text-left sm:text-right transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg hover:bg-gray-50 p-4 rounded-lg">
          <h2 className="font-bold text-xl sm:text-2xl lg:text-3xl border-b-4 border-[#0F6CB4] inline-block pb-1">
          Strategic Planning
          </h2>
          <p className="pt-2 text-sm sm:text-base">
          Our team creates a customized plan that leverages AI-powered solutions tailored to your specific needs, <br></br>ensuring maximum impact and growth. 
          </p>
        </div>

        <div className="transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg hover:bg-gray-50 p-4 rounded-lg">
          <h2 className="font-bold text-xl sm:text-2xl lg:text-3xl border-b-4 border-[#0F6CB4] inline-block pb-1">
          Execution & Development
          </h2>
          <p className="pt-2 text-sm sm:text-base">
          We implement the strategy with precision, whether it's launching a digital marketing campaign,<br></br> developing a website, or staffing your team, using cutting-edge tools and technologies. 
          </p>
        </div>

        <div className="text-left sm:text-right transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg hover:bg-gray-50 p-4 rounded-lg">
          <h2 className="font-bold text-xl sm:text-2xl lg:text-3xl border-b-4 border-[#0F6CB4] inline-block pb-1">
          Continuous Optimization
          </h2>
          <p className="pt-2 text-sm sm:text-base">
          We monitor progress and use data-driven insights to refine and optimize the solutions,<br></br> ensuring ongoing improvement and success. 
          </p>
        </div>

       
      </div>

      <div className="mt-8 w-full text-center px-4 sm:px-8">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold">
          Take the First Step Towards Digital{" "}
          <span className="text-black">Success</span>
        </h2>
        <p className="mb-8 sm:mt-8 text-base sm:text-xl font-semibold">
          Let's turn your business goals into real-world success stories.
          <br />
          Partner with <span className="font-bold">Glow Tech Solutions</span> —
          where innovation meets impact.
        </p>
      </div>
    </div>
  );
};

export default DigitalMarketingBenefits;
